import { Action, SubjectRoles } from "@/api-schema-enums";
import { AppAbility } from "@/casl-provider";
import { User } from "@/store/user-store";
import { AbilityBuilder } from "@casl/ability";

export function setModelGenerationPermissions(user: User, builder: AbilityBuilder<AppAbility>): void {
  const { can } = builder;

  if (!user.roles.includes(SubjectRoles.Int)) {
    return;
  }

  can(Action.Read, "ModelGeneration");

  if (user.roles.includes(SubjectRoles.MasterdataAdministrator)) {
    can(Action.Manage, "ModelGeneration");
  }
}
